import { ProcessCoreBase } from "./process.core.base"


export class ProcessCore extends ProcessCoreBase {

}